import { render, staticRenderFns } from "./loansCountCard.vue.html?vue&type=template&id=a9d4107e&"
import script from "./loansCountCard.ts?vue&type=script&lang=ts&"
export * from "./loansCountCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports